import styled from 'styled-components';

const CartErrorHeading = styled.h2`
  max-width: 100%;
  font-family: ${Styles.fontFamily.base};
  letter-spacing: -0.42px;
  line-height: 1;
  text-transform: ${Styles.textTransform.headlines};
  text-align: center;
  font-weight: 400;
  font-size: 2rem;
  margin-bottom: 0;

  ${Styles.desktop`
    max-width: 500px;
  `}
`;

export default CartErrorHeading;
